import { z } from 'zod'

import { generateRandomString } from '@mntn-dev/utilities'
import type { ZodInfer } from '@mntn-dev/utility-types'

export const MntnCustomerIdSchema = z.string().brand('mntn-customer-id')

export type MntnCustomerId = ZodInfer<typeof MntnCustomerIdSchema>

export const MntnCustomerId = (
  value: string = generateRandomString()
): MntnCustomerId => {
  return MntnCustomerIdSchema.parse(value)
}
